// extracted by mini-css-extract-plugin
export var header = "_uq-1";
export var maskBottom = "_uq-6";
export var maskMiddle = "_uq-7";
export var maskTop = "_uq-5";
export var root = "_uq-0";
export var scrollDownButton = "_uq-3";
export var scrollDownButtonHidden = "_uq-4";
export var viewport = "_uq-2";